var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPictureIcon = function SvgPictureIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 18c-.4 0-.75-.15-1.05-.45-.3-.3-.45-.65-.45-1.05v-15C0 1.1.15.75.45.45.75.15 1.1 0 1.5 0h15c.4 0 .75.15 1.05.45.3.3.45.65.45 1.05v15c0 .4-.15.75-.45 1.05-.3.3-.65.45-1.05.45h-15Zm0-1.5h15v-15h-15v15Zm2.15-2.425h10.725c.142 0 .248-.067.319-.2a.376.376 0 0 0-.019-.4l-2.925-3.9a.378.378 0 0 0-.3-.15.378.378 0 0 0-.3.15l-3 3.875-2.025-2.775a.379.379 0 0 0-.3-.15.379.379 0 0 0-.3.15l-2.15 2.8c-.1.133-.115.267-.044.4.071.133.177.2.319.2Z",
    fill: "#2C112D"
  })));
};
export default SvgPictureIcon;